// extracted by mini-css-extract-plugin
module.exports = {"faq_item":"faq-item_faq_item__mW4jT","faq_question":"faq-item_faq_question__eXUpv","faq_answer":"faq-item_faq_answer__85bFk","faq_link":"faq-item_faq_link__aHb5F"};